
<app-header></app-header>
<div style=" margin-top: 15px; padding: 10%" *ngIf="flag == 1 && staticdata && staticdata.length > 0" id="flag1">

    <p [innerHTML]="staticdata[0].about"> </p>
       
  </div>
  <div style=" margin-top: 15px; padding: 10%" *ngIf="flag == 2 && staticdata && staticdata.length > 0" id="flag2">
      <p [innerHTML]="staticdata[0].contact"> </p>
      </div>

  <div style=" margin-top: 15px; padding: 10%" *ngIf="flag == 3 && staticdata && staticdata.length > 0" id="flag3">
      <p [innerHTML]="staticdata[0].terms"> </p>
  </div>

  <div style=" margin-top: 15px; padding: 10%" *ngIf="flag == 4" id="flag4">
    <h2>  Privacy Policy </h2>
    <p>
      This privacy policy sets out how Blends Pet Solutions Pvt Ltd (owner of www.petcart.com) uses and protects any information that you give Blends Pet Solutions Pvt Ltd when you use this website (www.petcart.com).
    </p>
    <p>
      Blends Pet Solutions Pvt Ltd is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, and then you can be assured that it will only be used in accordance with this privacy statement.
    </p>
    <p>
      Blends Pet Solutions Pvt Ltd may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you are happy with any changes. This policy is effective from 21/11/2015
    </p>
      <p> 
     <b> What we collect </b>
      </p>
      <p>
      We may collect the following information:
      </p>
      <p>
      • name and job title <br>
      • contact information including email address <br>
      • demographic information such as postcode, preferences, interests and others <br>
      • other information relevant to customer surveys and/or offers <br>
      • information of your pets to provide better services <br>
      
       
      </p>
     <p><b> What we do with the information we gather</b> </p>
     <p>
      We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:
     </p>
     <p>
      • Internal record keeping. <br>
      • We may use the information to improve our products and services. <br>
      • We may periodically send promotional emails about new products, special offers or other information which we think you may find interesting using the email address which you have provided. <br>
      • From time to time, we may also use your information to contact you for market research purposes. We may contact you by email, phone, fax or mail. We may use the information to customise the website according to your interests. <br>
      
     </p>
      <p>
   <b>   Security </b>
      </p>
      <p>
      We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.
      </p>
      <p>
          <b> How we use cookies </b>
      </p>
      <p>
      A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyses web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences.
      We use traffic log cookies to identify which pages are being used. This helps us analyse data about webpage traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.
      Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.
      You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.
      
      <p>
          <b> Links to other websites </b>
      </p>
      <p>
      Our website may contain links to other websites of interest. However, once you have used these links to leave our site, you should note that we do not have any control over that other website. Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites and such sites are not governed by this privacy statement. You should exercise caution and look at the privacy statement applicable to the website in question.
      <p>
      <p>
          <b>  Controlling your personal information </b> 
      </p>
      <p>
      You may choose to restrict the collection or use of your personal information in the following ways:
      </p>
      <p>
      • whenever you are asked to fill in a form on the website, look for the box that you can click to indicate that you do not want the information to be used by anybody for direct marketing purposes <br>
      • if you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by writing to or emailing us at contact@petcart.com <br>
      <p>
      We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so. We may use your personal information to send you promotional information about third parties which we think you may find interesting if you tell us that you wish this to happen.
      </p><p>
      If you believe that any information we are holding on you is incorrect or incomplete, please write to or email us as soon as possible, at the above address. We will promptly correct any information found to be incorrect.
      </p>
      <p>
          <b>Contacting Us</b>
      </p>
      <p>    
      If there are any questions regarding this privacy policy you may contact us using the information below:
      </p>
      <p>
    <b>  Company Name: </b> Blends Pet Solutions Pvt Ltd <br>
    <b> Address: </b> No. T 138, 15th Main, 35th Cross, Jayanagar 4th T Block, Bangalore – 560041<br>
      <b> Telephone No: </b> +91 8861712345 / 080 41148447 <br>
        <b> E-Mail ID: </b> contact@petcart.com <br>
    </p>

  </div>

  <div style=" margin-top: 15px; padding: 10%" *ngIf="flag == 5" id="flag5">
    <h2>     Disclaimer: </h2>

    <p>
    
        The information contained in this website is for general information purposes only. The information is provided by Blends Pet Solutions Pvt Ltd and while we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.
        
    </p>
    <p>   
        
        In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arise out of, or in connection with, the use of this website.
    </p>
    <p>
         
        
        Through this website you are able to link to other websites which are not under the control of Blends Pet Solutions Pvt Ltd. We have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.
    </p>
    <p>  
         
        
        Every effort is made to keep the website up and running smoothly. However, Blends Pet Solutions Pvt Ltd takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.

    </p>

  </div>

  <div style=" margin-top: 15px; padding: 10%" *ngIf="flag == 6" id="flag6">
     <h2> Cancellation Policy: </h2>
      
     <p>
     Blends Pet Solutions Pvt Ltd believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:
     </p>
    <p>
     • Cancellations will be considered only if the request is made within 72 hours of placing an order. However, the cancellation request will not be entertained if the orders have been initiated for shipping. <br>
     • There is no cancellation of orders placed under the Same Day Delivery category. <br>
     • No cancellations are entertained for those products that the Blends Pet Solutions Pvt Ltd's marketing team has obtained on special occasions like New Year, Diwali etc. These are limited occasion offers and therefore cancellations are not possible. <br>
     • Blends Pet Solutions Pvt Ltd does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good. <br>
     • In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once we have checked and determined the same at our end. This should be reported within 5 days of receipt of the products. <br>
     • In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service team within 24 hours of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision. <br>
     • In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them. <br>
    </p>
     
     
   <h2>  Refund Policy: </h2>
      
   <p>
     
     •  Consumable items will not be returned or refunded, in case the seal is broken. This includes food, grooming products, supplements, fashion accessories / apparel, beds etc <br>
     •  In case of damaged or any missing product the customer needs to raise the request within 24hours from the time of delivery <br>
     •  All items to be returned must be unused and in their original condition with all bills and packaging and tags should not be broken or tampered with <br>
     •  In the event Blends Pet Solutions Pvt Ltd accepts the return request raised by the customer, customer will have to return the product and then the refund shall be credited to the customer’s account. <br>
     •  Refund will only be processed after a quality check of the product by experts of Blends Pet Solutions Pvt Ltd <br>  
      
   </p>
   <p>
    <b> Please note that the product should be unused and should be sent back along with original box and invoice to: </b> <br>
     Customer care <br>
     Blends Pet Solutions Pvt Ltd <br>
     No. T 138, 15th Main, 35th Cross, <br>
     Jayanagar 4th T Block, Bangalore – 560041
    </p>
    <p>
     The refund process will be initiated once we have received the product(s). Refunds are processed in less than 10 working days but in case of payments by Cheque or DD, it may take a few extra days for the cheque to be delivered to your billing address, and for the funds to be credited to your account, once you deposit the cheque.
     </p>
    </div>

    <div style=" margin-top: 15px; padding: 10%" *ngIf="flag == 7" id="flag7">
      <p>
      <a style=" color: red">  Currently we are delivering only within Bangalore. </a> Free Shipping is available for orders of Rs. 500 or more. Shipping charge of Rs. 99 is applicable for orders of less than Rs. 500.
      </p>
       <p style=" color: red">
       Orders placed are usually delivered within 24 - 48 hours. Orders placed on Saturday evening or Sunday will be delivered on Monday. There will be no dispatch on 26th January, 1st May and 15th August, any order placed / to be dispatched on these days will be delivered on the next working day. 
       </p>
       
       
      <h2> Shipping & Delivery Policy (Products) </h2>
       <p>
       For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only.
       </p>
       <p>
       For domestic buyers, orders are shipped through registered domestic courier/logistics companies and /or speed post and /or our delivery team only. Orders are shipped within 7 working days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms.
      </p>
      <p>
       Blends Pet Solutions Pvt Ltd is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier/logistics company or postal authorities within 7 working days from the date of the order and payment or as per the delivery date agreed at the time of order confirmation.
      </p>
      <p>
       Delivery of all orders will be to registered address of the buyer as per the credit/debit card only at all times(Unless specified at the time of Order).
      </p>
      <p>
       Blends Pet Solutions Pvt Ltd is in no way responsible for any damage to the order while in transit to the buyer.
      </p>
      <p>
       Blends Pet Solutions Pvt Ltd is proud to use EBS for fast, easy and efficient secure payments. All major payment modes are accepted.
      </p>
        
      <h2> Shipping & Delivery Policy (Services)</h2>
      <p>
       Delivery of our services will be confirmed on your mail ID / phone as specified during registration. For any issues in utilizing our services you may contact our helpdesk on +91 8861712345
      </p>
        
      <h2> Shipping Charges </h2>
      <p>
       Shipping Charge of Rs. 99 is applicable for orders less than Rs. 500. International shipping rates will be communicated to the customers during the order process
      </p>
      <p>
       Any applicable Octroi charge levied by state governments is payable by the recipient at the time of delivery. The Octroi amount will be collected from the recipient at the time of delivery.
      </p>
      </div>

    

